const translationKeys = {
  pension_overview_header_title: 'pension_overview_header_title',
  pension_overview_header_text: 'pension_overview_header_text',
  pension_overview_agreements_from_customer_list_title:
    'pension_overview_agreements_from_customer_list_title',
  pension_overview_agreements_from_customer_list_modal_title:
    'pension_overview_agreements_from_customer_list_modal_title',
  pension_overview_agreements_from_customer_list_modal_description:
    'pension_overview_agreements_from_customer_list_modal_description',
  pension_overview_agreements_from_customer_list_no_products:
    'pension_overview_agreements_from_customer_list_no_products',
  pension_overview_agreement_cell_saved_pension:
    'pension_overview_agreement_cell_saved_pension',
  pension_overview_pension_from_state_title:
    'pension_overview_pension_from_state_title',
  pension_overview_pension_from_state_modal_title:
    'pension_overview_pension_from_state_modal_title',
  pension_overview_pension_from_state_modal_description:
    'pension_overview_pension_from_state_modal_description',
  pension_overview_pension_from_state_subtitle:
    'pension_overview_pension_from_state_subtitle',
  pension_overview_pension_from_state_description:
    'pension_overview_pension_from_state_description',
  pension_overview_pension_from_state_description_pension_calculator_link:
    'pension_overview_pension_from_state_description_pension_calculator_link',
  pension_overview_pension_from_state_description_norskpensjon_link:
    'pension_overview_pension_from_state_description_norskpensjon_link',
  pension_overview_agreements_from_customer_list_subtitle:
    'pension_overview_agreements_from_customer_list_subtitle',
  pension_overview_header_norskpensjon_link:
    'pension_overview_header_norskpensjon_link',
  pension_overview_header_pension_calculator_button:
    'pension_overview_header_pension_calculator_button',
  pension_overview_agreements_from_employer_list_title:
    'pension_overview_agreements_from_employer_list_title',
  pension_overview_agreements_from_employer_list_subtitle:
    'pension_overview_agreements_from_employer_list_subtitle',
  pension_overview_pension_from_employer_modal_title:
    'pension_overview_pension_from_employer_modal_title',
  pension_overview_pension_from_employer_modal_description:
    'pension_overview_pension_from_employer_modal_description',
  pension_account_information_button: 'pension_account_information_button',
  pension_account_details_title: 'pension_account_details_title',
  pension_account_details_description_defined_contribution:
    'pension_account_details_description_defined_contribution',
  pension_account_details_description_company_agreement:
    'pension_account_details_description_company_agreement',
  pension_account_tab_investment_choice:
    'pension_account_tab_investment_choice',
  pension_account_tab_payments: 'pension_account_tab_payments',
  pension_account_tab_sickness_or_death:
    'pension_account_tab_sickness_or_death',
  pension_account_details_employer: 'pension_account_details_employer',
  pension_account_tab_investment_choice_change_in_progress:
    'pension_account_tab_investment_choice_change_in_progress',
  pension_account_tab_investment_choice_not_changed:
    'pension_account_tab_investment_choice_not_changed',
  pension_account_tab_investment_choice_last_changed:
    'pension_account_tab_investment_choice_last_changed',
  pension_account_tab_investment_choice_corporate_scheme:
    'pension_account_tab_investment_choice_corporate_scheme',
  pension_account_tab_investment_choice_corporate_scheme_modal_title:
    'pension_account_tab_investment_choice_corporate_scheme_modal_title',
  pension_account_tab_investment_choice_corporate_scheme_modal_description:
    'pension_account_tab_investment_choice_corporate_scheme_modal_description',
  pension_account_tab_investment_choice_corporate_scheme_tag_label:
    'pension_account_tab_investment_choice_corporate_scheme_tag_label',
  pension_account_tab_sickness_or_death_sickness_title:
    'pension_account_tab_sickness_or_death_sickness_title',
  pension_account_tab_sickness_or_death_sickness_description:
    'pension_account_tab_sickness_or_death_sickness_description',
  pension_account_tab_sickness_or_death_death_title:
    'pension_account_tab_sickness_or_death_death_title',
  pension_account_tab_sickness_or_death_death_description:
    'pension_account_tab_sickness_or_death_death_description',
  pension_account_tab_investment_choice_graph_interest:
    'pension_account_tab_investment_choice_graph_interest',
  pension_account_tab_investment_choice_graph_equity:
    'pension_account_tab_investment_choice_graph_equity',
  pension_account_tab_investment_choice_graph_info:
    'pension_account_tab_investment_choice_graph_info',
  pension_account_tab_payments_description:
    'pension_account_tab_payments_description',
  pension_account_tab_payments_current_employer:
    'pension_account_tab_payments_current_employer',
  pension_account_tab_payments_previous_employer:
    'pension_account_tab_payments_previous_employer',
  pension_account_tab_investment_choice_custom_profile:
    'pension_account_tab_investment_choice_custom_profile',
  pension_account_tab_investment_choice_profile_name_no_downweighting:
    'pension_account_tab_investment_choice_profile_name_no_downweighting',
  pension_account_tab_investment_choice_profile_name_with_downweighting:
    'pension_account_tab_investment_choice_profile_name_with_downweighting',
  pension_account_ip_moving_in_progress:
    'pension_account_ip_moving_in_progress',
  pension_account_ip_moving_completed: 'pension_account_ip_moving_completed',
  pension_account_reinvestment_info: 'pension_account_reinvestment_info',
  pension_account_performance_error: 'pension_account_performance_error',
  pension_account_change_investment_button:
    'pension_account_change_investment_button',
  pension_change_profile_header_title: 'pension_change_profile_header_title',
  pension_account_details_agreement_number:
    'pension_account_details_agreement_number',
  pension_account_details_agreement_type:
    'pension_account_details_agreement_type',
  pension_account_details_enrolled_date:
    'pension_account_details_enrolled_date',
  pension_account_details_more_info_button:
    'pension_account_details_more_info_button',
  pension_account_details_agreement_type_inskuddspensjon:
    'pension_account_details_agreement_type_inskuddspensjon',
  pension_account_details_agreement_type_pkb:
    'pension_account_details_agreement_type_pkb',
  pension_account_monthly_transactions_current_employer:
    'pension_account_monthly_transactions_current_employer',
  pension_account_monthly_transactions_previous_employer:
    'pension_account_monthly_transactions_previous_employer',
  pension_account_monthly_transactions_empty:
    'pension_account_monthly_transactions_empty',
  pension_account_monthly_transactions_old_information:
    'pension_account_monthly_transactions_old_information',
  pension_account_monthly_transactions_month:
    'pension_account_monthly_transactions_month',
  pension_account_monthly_transactions_amount:
    'pension_account_monthly_transactions_amount',
  pension_account_monthly_transactions_year:
    'pension_account_monthly_transactions_year',
  pension_account_monthly_transactions_this_year:
    'pension_account_monthly_transactions_this_year',
  pension_account_monthly_transactions_error:
    'pension_account_monthly_transactions_error',
  pension_overview_agreements_from_customer_list_empty:
    'pension_overview_agreements_from_customer_list_empty',
  pension_overview_agreements_from_employer_list_empty:
    'pension_overview_agreements_from_employer_list_empty',
  pension_overview_agreement_cell_flex_onboarding_in_progress:
    'pension_overview_agreement_cell_flex_onboarding_in_progress',
  pension_overview_agreement_cell_guaranteed_amount:
    'pension_overview_agreement_cell_guaranteed_amount',
  pension_overview_agreement_cell_not_available:
    'pension_overview_agreement_cell_not_available',
  pension_overview_agreement_cell_inactive:
    'pension_overview_agreement_cell_inactive',
  pension_overview_agreement_cell_could_not_fetch:
    'pension_overview_agreement_cell_could_not_fetch',
  pension_overview_agreement_cell_try_again_button:
    'pension_overview_agreement_cell_try_again_button',
  pension_overview_agreement_cell_balance_unavailable:
    'pension_overview_agreement_cell_balance_unavailable',
  pension_overview_agreement_cell_epk_flex_termination_in_progress:
    'pension_overview_agreement_cell_epk_flex_termination_in_progress',
  pension_expected_payout_title: 'pension_expected_payout_title',
  pension_expected_payout_modal_title: 'pension_expected_payout_modal_title',
  pension_expected_payout_modal_content:
    'pension_expected_payout_modal_content',
  pension_expected_payout_description: 'pension_expected_payout_description',
  pension_expected_payout_high: 'pension_expected_payout_high',
  pension_expected_payout_expected: 'pension_expected_payout_expected',
  pension_expected_payout_low: 'pension_expected_payout_low',
  pension_contribution_plan_title: 'pension_contribution_plan_title',
  pension_contribution_plan_reinvestment_info:
    'pension_contribution_plan_reinvestment_info',
  pension_contribution_plan_description:
    'pension_contribution_plan_description',
  pension_contribution_plan_from_to_g: 'pension_contribution_plan_from_to_g',
  pension_contribution_plan_fixed_amount:
    'pension_contribution_plan_fixed_amount',
  pension_contribution_plan_percentage_of_g:
    'pension_contribution_plan_percentage_of_g',
  pension_individual_details_title: 'pension_individual_details_title',
  pension_individual_details_agreement_number:
    'pension_individual_details_agreement_number',
  pension_individual_details_guaranteed_amount:
    'pension_individual_details_guaranteed_amount',
  pension_individual_details_guaranteed_amount_modal_title:
    'pension_individual_details_guaranteed_amount_modal_title',
  pension_individual_details_guaranteed_amount_modal_content:
    'pension_individual_details_guaranteed_amount_modal_content',
  pension_individual_details_combination_choice:
    'pension_individual_details_combination_choice',
  pension_individual_details_combination_choice_modal_title:
    'pension_individual_details_combination_choice_modal_title',
  pension_individual_details_combination_choice_modal_content:
    'pension_individual_details_combination_choice_modal_content',
  pension_individual_details_investment_choice:
    'pension_individual_details_investment_choice',
  pension_individual_details_investment_choice_modal_title:
    'pension_individual_details_investment_choice_modal_title',
  pension_individual_details_investment_choice_modal_content:
    'pension_individual_details_investment_choice_modal_content',
  pension_individual_costs_title: 'pension_individual_costs_title',
  pension_individual_costs_description: 'pension_individual_costs_description',
  pension_individual_costs_administration_fee_title:
    'pension_individual_costs_administration_fee_title',
  pension_individual_costs_administration_fee_modal_content_guaranteed_amount:
    'pension_individual_costs_administration_fee_modal_content_guaranteed_amount',
  pension_individual_costs_administration_fee_modal_title:
    'pension_individual_costs_administration_fee_modal_title',
  pension_individual_costs_administration_fee_modal_content_investment_choice:
    'pension_individual_costs_administration_fee_modal_content_investment_choice',
  pension_individual_costs_management_fee_title:
    'pension_individual_costs_management_fee_title',
  pension_individual_costs_management_fee_modal_content_guaranteed_amount:
    'pension_individual_costs_management_fee_modal_content_guaranteed_amount',
  pension_individual_costs_management_fee_modal_title:
    'pension_individual_costs_management_fee_modal_title',
  pension_individual_costs_management_fee_modal_content_investment_choice:
    'pension_individual_costs_management_fee_modal_content_investment_choice',
  pension_individual_costs_management_fee_cost:
    'pension_individual_costs_management_fee_cost',
  pension_disbursement_details_title: 'pension_disbursement_details_title',
  pension_disbursement_details_under_reinvestment:
    'pension_disbursement_details_under_reinvestment',
  pension_disbursement_details_first_payout_age:
    'pension_disbursement_details_first_payout_age',
  pension_disbursement_details_first_payout_age_value:
    'pension_disbursement_details_first_payout_age_value',
  pension_disbursement_details_payout_duration:
    'pension_disbursement_details_payout_duration',
  pension_disbursement_details_payout_duration_value:
    'pension_disbursement_details_payout_duration_value',
  pension_disbursement_details_minimum_payout_end_age:
    'pension_disbursement_details_minimum_payout_end_age',
  pension_disbursement_details_minimum_payout_end_age_value:
    'pension_disbursement_details_minimum_payout_end_age_value',
  pension_disbursement_details_description:
    'pension_disbursement_details_description',
  pension_individual_moving_to_epk_ipa_info:
    'pension_individual_moving_to_epk_ipa_info',
  pension_individual_moving_to_epk_ips_info:
    'pension_individual_moving_to_epk_ips_info',
  pension_individual_guaranteed_amount_info_ips:
    'pension_individual_guaranteed_amount_info_ips',
  pension_individual_guaranteed_amount_info_ipa:
    'pension_individual_guaranteed_amount_info_ipa',
  pension_individual_more_information: 'pension_individual_more_information',
  pension_individual_my_agreements_button:
    'pension_individual_my_agreements_button',
  pension_pkb_secure_agreement_number: 'pension_pkb_secure_agreement_number',
  pension_pkb_secure_guaranteed_amount: 'pension_pkb_secure_guaranteed_amount',
  pension_pkb_secure_details_title: 'pension_pkb_secure_details_title',
  pension_pkb_secure_guaranteed_amount_dialog_title:
    'pension_pkb_secure_guaranteed_amount_dialog_title',
  pension_pkb_secure_guaranteed_amount_dialog_content:
    'pension_pkb_secure_guaranteed_amount_dialog_content',
  pension_pkb_secure_costs_title: 'pension_pkb_secure_costs_title',
  pension_pkb_secure_costs_description: 'pension_pkb_secure_costs_description',
  pension_pkb_secure_costs_administration_fee_title:
    'pension_pkb_secure_costs_administration_fee_title',
  pension_pkb_secure_costs_administration_fee_dialog_title:
    'pension_pkb_secure_costs_administration_fee_dialog_title',
  pension_pkb_secure_costs_administration_fee_dialog_content:
    'pension_pkb_secure_costs_administration_fee_dialog_content',
  pension_pkb_secure_costs_management_fee_title:
    'pension_pkb_secure_costs_management_fee_title',
  pension_pkb_secure_costs_management_fee_dialog_title:
    'pension_pkb_secure_costs_management_fee_dialog_title',
  pension_pkb_secure_costs_management_fee_dialog_content:
    'pension_pkb_secure_costs_management_fee_dialog_content',
  pension_pkb_secure_costs_management_fee_value:
    'pension_pkb_secure_costs_management_fee_value',
  pension_pkb_secure_moving_to_epk_info:
    'pension_pkb_secure_moving_to_epk_info',
  pension_pkb_secure_moving_to_epk_pkb_pluss_info:
    'pension_pkb_secure_moving_to_epk_pkb_pluss_info',
  pension_pkb_secure_moving_to_epk_guaranteed_amount_info:
    'pension_pkb_secure_moving_to_epk_guaranteed_amount_info',
  pension_pkb_secure_more_information: 'pension_pkb_secure_more_information',
  pension_pkb_secure_my_agreements_button:
    'pension_pkb_secure_my_agreements_button',
  pension_account_tab_investment_choice_investment_information:
    'pension_account_tab_investment_choice_investment_information',
  pension_account_tab_investment_choice_investment_information_mpp:
    'pension_account_tab_investment_choice_investment_information_mpp',
  pension_account_details_compensation_title:
    'pension_account_details_compensation_title',
  pension_account_details_compensation_modal_title:
    'pension_account_details_compensation_modal_title',
  pension_account_details_compensation_modal_content:
    'pension_account_details_compensation_modal_content',
  pension_account_details_compensation_reinvestment_info:
    'pension_account_details_compensation_reinvestment_info',
  pension_account_details_compensation_rate:
    'pension_account_details_compensation_rate',
  pension_account_details_support_info: 'pension_account_details_support_info',
  pension_account_details_description_company_agreement_flex_onboarding_button:
    'pension_account_details_description_company_agreement_flex_onboarding_button',
  pension_extended_profile_information_trigger_text:
    'pension_extended_profile_information_trigger_text',
  pension_extended_profile_information_title:
    'pension_extended_profile_information_title',
  pension_extended_profile_information_distribution_title:
    'pension_extended_profile_information_distribution_title',
  pension_down_weighting_title: 'pension_down_weighting_title',
  pension_down_weighting_custom_profile:
    'pension_down_weighting_custom_profile',
  pension_down_weighting_turned_off: 'pension_down_weighting_turned_off',
  pension_down_weighting_started: 'pension_down_weighting_started',
  pension_down_weighting_completed_old_profile:
    'pension_down_weighting_completed_old_profile',
  pension_down_weighting_completed_new_profile:
    'pension_down_weighting_completed_new_profile',
  pension_down_weighting_equal_allocation:
    'pension_down_weighting_equal_allocation',
  pension_down_weighting_old_profile: 'pension_down_weighting_old_profile',
  pension_down_weighting_new_profile: 'pension_down_weighting_new_profile',
  pension_down_weighting_change_button_text:
    'pension_down_weighting_change_button_text',
  pension_account_tab_investment_choice_calculations_error:
    'pension_account_tab_investment_choice_calculations_error',
  pension_pkb_reservation_title: 'pension_pkb_reservation_title',
  pension_pkb_reservation_description: 'pension_pkb_reservation_description',
  pension_pkb_reservation_description_insurance_included:
    'pension_pkb_reservation_description_insurance_included',
  pension_pkb_reservation_pkb_pluss_info:
    'pension_pkb_reservation_pkb_pluss_info',
  pension_pkb_reservation_payout_started_info:
    'pension_pkb_reservation_payout_started_info',
  pension_pkb_reservation_norskpensjon_description:
    'pension_pkb_reservation_norskpensjon_description',
  pension_pkb_reservation_norskpensjon_info_1:
    'pension_pkb_reservation_norskpensjon_info_1',
  pension_pkb_reservation_norskpensjon_info_2:
    'pension_pkb_reservation_norskpensjon_info_2',
  pension_pkb_reservation_norskpensjon_info_3:
    'pension_pkb_reservation_norskpensjon_info_3',
  pension_pkb_reservation_norskpensjon_info_4:
    'pension_pkb_reservation_norskpensjon_info_4',
  pension_pkb_reservation_norskpensjon_button:
    'pension_pkb_reservation_norskpensjon_button',
  pension_pkb_investment_information: 'pension_pkb_investment_information',
  pension_pkb_investment_information_payout_started:
    'pension_pkb_investment_information_payout_started',
  pension_account_flex_agreement_termination_in_progress_info:
    'pension_account_flex_agreement_termination_in_progress_info',
  pension_account_flex_all_contracts_termination_in_progress_info:
    'pension_account_flex_all_contracts_termination_in_progress_info',
  pension_account_flex_product_onboard_not_completed_info:
    'pension_account_flex_product_onboard_not_completed_info',
  pension_account_flex_reinvestment_in_progress:
    'pension_account_flex_reinvestment_in_progress',
  pension_pkb_details_description: 'pension_pkb_details_description',
  pension_pkb_details_agreement_number: 'pension_pkb_details_agreement_number',
  pension_pkb_details_agreements_button:
    'pension_pkb_details_agreements_button',
  pension_change_profile_choose_profile_step_title:
    'pension_change_profile_choose_profile_step_title',
  pension_change_profile_summary_step_title:
    'pension_change_profile_summary_step_title',
  pension_change_profile_choose_profile_step_description:
    'pension_change_profile_choose_profile_step_description',
  pension_change_profile_choose_profile_step_cancel_button:
    'pension_change_profile_choose_profile_step_cancel_button',
  pension_change_profile_choose_profile_step_next_button:
    'pension_change_profile_choose_profile_step_next_button',
  pension_change_profile_summary_step_description:
    'pension_change_profile_summary_step_description',
  pension_change_profile_summary_step_back_button:
    'pension_change_profile_summary_step_back_button',
  pension_change_profile_summary_step_cancel_button:
    'pension_change_profile_summary_step_cancel_button',
  pension_change_profile_summary_step_complete_button:
    'pension_change_profile_summary_step_complete_button',
  pension_change_profile_choose_profile_step_current_investment_title:
    'pension_change_profile_choose_profile_step_current_investment_title',
  pension_change_profile_profile_card_title_custom_profile:
    'pension_change_profile_profile_card_title_custom_profile',
  pension_change_profile_profile_card_title_custom_profile_flex:
    'pension_change_profile_profile_card_title_custom_profile_flex',
  pension_change_profile_profile_card_allocation_title:
    'pension_change_profile_profile_card_allocation_title',
  pension_change_profile_profile_card_allocation_interest_bar_title:
    'pension_change_profile_profile_card_allocation_interest_bar_title',
  pension_change_profile_profile_card_allocation_equity_bar_title:
    'pension_change_profile_profile_card_allocation_equity_bar_title',
  pension_account_flex_product_name: 'pension_account_flex_product_name',
  pension_account_flex_product_type_tag:
    'pension_account_flex_product_type_tag',
  pension_account_flex_product_type_dialog_description:
    'pension_account_flex_product_type_dialog_description',
  pension_account_flex_product_type_dialog_title:
    'pension_account_flex_product_type_dialog_title',
  pension_pkb_investment_annual_costs_title:
    'pension_pkb_investment_annual_costs_title',
  pension_pkb_investment_annual_costs_description:
    'pension_pkb_investment_annual_costs_description',
  pension_pkb_investment_administration_fee_title:
    'pension_pkb_investment_administration_fee_title',
  pension_pkb_investment_administration_fee_dialog_description:
    'pension_pkb_investment_administration_fee_dialog_description',
  pension_pkb_investment_administration_fee_dialog_title:
    'pension_pkb_investment_administration_fee_dialog_title',
  pension_pkb_investment_management_fee_title:
    'pension_pkb_investment_management_fee_title',
  pension_pkb_investment_management_fee_value:
    'pension_pkb_investment_management_fee_value',
  pension_pkb_investment_management_fee_dialog_title:
    'pension_pkb_investment_management_fee_dialog_title',
  pension_pkb_investment_management_fee_dialog_description:
    'pension_pkb_investment_management_fee_dialog_description',
  pension_change_profile_choose_profile_step_new_investment_title:
    'pension_change_profile_choose_profile_step_new_investment_title',
  pension_annual_costs_title: 'pension_annual_costs_title',
  pension_annual_costs_dialog_title: 'pension_annual_costs_dialog_title',
  pension_annual_costs_dialog_description:
    'pension_annual_costs_dialog_description',
  pension_annual_costs_description: 'pension_annual_costs_description',
  pension_annual_costs_value: 'pension_annual_costs_value',
  pension_annual_costs_employer_pays: 'pension_annual_costs_employer_pays',
  pension_change_profile_summary_step_key_information_switch:
    'pension_change_profile_summary_step_key_information_switch',
  pension_change_profile_summary_step_from:
    'pension_change_profile_summary_step_from',
  pension_change_profile_summary_step_to:
    'pension_change_profile_summary_step_to',
  pension_change_down_weighting_standard_title:
    'pension_change_down_weighting_standard_title',
  pension_change_down_weighting_standard_dialog_title:
    'pension_change_down_weighting_standard_dialog_title',
  pension_change_down_weighting_standard_dialog_description:
    'pension_change_down_weighting_standard_dialog_description',
  pension_change_down_weighting_standard_description_current:
    'pension_change_down_weighting_standard_description_current',
  pension_change_down_weighting_standard_description:
    'pension_change_down_weighting_standard_description',
  pension_change_down_weighting_standard_chart_title:
    'pension_change_down_weighting_standard_chart_title',
  pension_change_down_weighting_custom_title_current:
    'pension_change_down_weighting_custom_title_current',
  pension_change_down_weighting_custom_title:
    'pension_change_down_weighting_custom_title',
  pension_change_down_weighting_custom_dialog_title:
    'pension_change_down_weighting_custom_dialog_title',
  pension_change_down_weighting_custom_dialog_description:
    'pension_change_down_weighting_custom_dialog_description',
  pension_change_down_weighting_off_title_current:
    'pension_change_down_weighting_off_title_current',
  pension_change_down_weighting_off_title:
    'pension_change_down_weighting_off_title',
  pension_change_down_weighting_off_dialog_title:
    'pension_change_down_weighting_off_dialog_title',
  pension_change_down_weighting_off_dialog_description:
    'pension_change_down_weighting_off_dialog_description',
  pension_change_down_weighting_custom_description_current:
    'pension_change_down_weighting_custom_description_current',
  pension_change_down_weighting_custom_description:
    'pension_change_down_weighting_custom_description',
  pension_change_down_weighting_off_description_current:
    'pension_change_down_weighting_off_description_current',
  pension_change_down_weighting_off_description:
    'pension_change_down_weighting_off_description',
  pension_change_down_weighting_current_option_title:
    'pension_change_down_weighting_current_option_title',
  pension_change_down_weighting_current_profile_option_title:
    'pension_change_down_weighting_current_profile_option_title',
  pension_change_down_weighting_new_options_title:
    'pension_change_down_weighting_new_options_title',
  pension_change_down_weighting_title: 'pension_change_down_weighting_title',
  pension_change_down_weighting_choose_step:
    'pension_change_down_weighting_choose_step',
  pension_change_down_weighting_summary_step:
    'pension_change_down_weighting_summary_step',
};

Object.freeze(translationKeys);

export default translationKeys;
